export default "__VITE_ASSET__BaVzYYw8__"